import { Component } from '@angular/core';
import { Icon } from '../icon';

@Component({
  selector: 'iconmonstr-check-mark',
  templateUrl: './check-mark.component.html',
})
export class CheckMarkComponent extends Icon {
}
